/**
 * This function helps the matcher to make better assertions.
 * Removes spaces and dashes.
 */
export function stripSpacesAndDashesFromInput(input) {
    return input.replace(/\s+/g, '').replace(/-/g, '');
}
